import { useLanguage } from '@/contexts/LanguageContext';

interface TableEmptyStateProps {
  children?: React.ReactNode;
}

export function TableEmptyState({ children }: TableEmptyStateProps) {
  const { t } = useLanguage();
  return (
    <p className="text-sm text-muted-foreground">
      {children ?? t('common.noResults')}
    </p>
  );
}
